var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var DragItem = (function (_super) {
    __extends(DragItem, _super);
    function DragItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragItem.prototype.mousedown = function (e) {
        if (this.prevent)
            e.stopPropagation();
    };
    DragItem.prototype.mouseup = function (e) {
        if (this.prevent)
            e.stopPropagation();
    };
    DragItem.prototype.deleteItem = function () {
        this.$emit('close');
    };
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], DragItem.prototype, "closeable", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], DragItem.prototype, "prevent", void 0);
    DragItem = __decorate([
        Component()
    ], DragItem);
    return DragItem;
}(Vue));
export default DragItem;
